// src/pages/suppliers/CreateSupplier.jsx

import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditSupplier from "../../components/suppliers/FormAddEditSupplier";

const CreateSupplier = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/suppliers");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSupplier
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateSupplier;
